import {greaterThanNow} from './time'
export const debounce = function(fn, wait) {
  let timeout = null;
  return function() {
      if(timeout !== null)   clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
  }
}

// 大于现在的数组, 去掉过期时间
export const filterTimeGreaterThanNow = function(data){
  if(!data || data.length===0){
    return []
  }
  return data.filter(item=>{
    return greaterThanNow(item.showDateTime)
  })
}
